import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { PermissionGate } from "@/components/PermissionGate";
import { projectPageModule } from "@/components/layout/navConfig";
import { ArrowLeft, FolderX } from "lucide-react";
import { useProjectCtx } from "@/context/ProjectContext";
import { ProjectHeader } from "@/components/layout/ProjectHeader";

export function ProjectShell() {
  const { project, projectId, projectRole, loading, loadError } = useProjectCtx();
  const navigate = useNavigate();
  const location = useLocation();

  if (loadError) {
    return (
      <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 text-center" data-testid="project-not-found-state">
        <FolderX className="h-10 w-10 text-muted-foreground" />
        <h1 className="font-heading text-lg font-bold text-foreground">Project not found</h1>
        <p className="max-w-sm text-sm text-muted-foreground" data-testid="project-not-found-message">{loadError.message}</p>
        <button
          data-testid="project-not-found-back-button"
          onClick={() => navigate("/")}
          className="mt-2 flex items-center gap-1.5 rounded-md border border-border px-3 py-1.5 text-sm font-medium text-foreground hover:bg-accent"
        >
          <ArrowLeft className="h-3.5 w-3.5" /> Back to Portfolio
        </button>
      </div>
    );
  }

  if (loading && !project) {
    return <div className="py-16 text-center text-sm text-muted-foreground" data-testid="project-shell-loading">Loading project…</div>;
  }

  return (
    <div className="space-y-4">
      <ProjectHeader project={project} projectId={projectId} projectRole={projectRole} onBack={() => navigate("/")} />

      <PermissionGate module={projectPageModule(location.pathname.split("/")[3] || "")}><Outlet /></PermissionGate>
    </div>
  );
}

